(function(){
  "use strict";
  var HNC_VARIANTS={"tee-crate": {"S|physical": 43512023711778, "S|virtual": 45364560298018, "M|physical": 43512023744546, "M|virtual": 45364560330786, "L|physical": 43512023777314, "L|virtual": 45364560363554, "XL|physical": 43512023810082, "XL|virtual": 45364560396322, "2XL|physical": 43512023842850, "2XL|virtual": 45364560429090, "_default": 43512023711778}, "starter-crate": {"S": 45419516395554, "M": 45419516428322, "L": 45419516461090, "XL": 45419516493858, "2XL": 45419516526626, "_default": 45419516395554}, "all-star-crate": {"S|physical": 43608073994274, "S|virtual": 45364561248290, "M|physical": 43608074027042, "M|virtual": 45364561281058, "L|physical": 43608074059810, "L|virtual": 45364561313826, "XL|physical": 43608074092578, "XL|virtual": 45364561346594, "2XL|physical": 43608074125346, "2XL|virtual": 45364561379362, "_default": 43608073994274}, "all-time-great-crate": {"S|virtual": 43877237063714, "S|physical": 45364555808802, "M|virtual": 43877237096482, "M|physical": 45364555841570, "XL|virtual": 43877237162018, "XL|physical": 45364555874338, "2XL|virtual": 43877237194786, "2XL|physical": 45364555907106, "L|virtual": 45364562460706, "L|physical": 45364562526242, "_default": 43877237063714}, "goat-crate": {"S|physical": 43512015781922, "S|virtual": 45364559806498, "M|physical": 43512015814690, "M|virtual": 45364559839266, "L|physical": 43512015847458, "L|virtual": 45364559872034, "XL|physical": 43512015880226, "XL|virtual": 45364559904802, "2XL|physical": 43512015912994, "2XL|virtual": 45364559937570, "_default": 43512015781922}, "mega-goat-crate": {"S|physical": 43790276952098, "S|virtual": 45364561641506, "M|physical": 43790276984866, "M|virtual": 45364561674274, "L|physical": 43790277017634, "L|virtual": 45364561707042, "XL|physical": 43790277050402, "XL|virtual": 45364561739810, "2XL|physical": 43790277083170, "2XL|virtual": 45364561772578, "_default": 43790276952098}};
  // ===== QUICK BUY: variant map + experience/size state =====
var HNC_VARIANTS={
  "tee-crate":          {S:"43512023711778",M:"43512023744546",L:"43512023777314",XL:"43512023810082","2XL":"43512023842850","S|virtual":"45364560298018","M|virtual":"45364560330786","L|virtual":"45364560363554","XL|virtual":"45364560396322","2XL|virtual":"45364560429090"},
  "starter-crate":      {S:"45419516395554",M:"45419516428322",L:"45419516461090",XL:"45419516493858","2XL":"45419516526626"},
  "all-star-crate":     {S:"43608073994274",M:"43608074027042",L:"43608074059810",XL:"43608074092578","2XL":"43608074125346","S|virtual":"45364561248290","M|virtual":"45364561281058","L|virtual":"45364561313826","XL|virtual":"45364561346594","2XL|virtual":"45364561379362"},
  "all-time-great-crate":{S:"45364555808802",M:"45364555841570",L:"45364562526242",XL:"45364555874338","2XL":"45364555907106","S|virtual":"43877237063714","M|virtual":"43877237096482","L|virtual":"45364562460706","XL|virtual":"43877237162018","2XL|virtual":"43877237194786"},
  "goat-crate":         {S:"43512015781922",M:"43512015814690",L:"43512015847458",XL:"43512015880226","2XL":"43512015912994","S|virtual":"45364559806498","M|virtual":"45364559839266","L|virtual":"45364559872034","XL|virtual":"45364559904802","2XL|virtual":"45364559937570"},
  "mega-goat-crate":    {S:"43790276952098",M:"43790276984866",L:"43790277017634",XL:"43790277050402","2XL":"43790277083170","S|virtual":"45364561641506","M|virtual":"45364561674274","L|virtual":"45364561707042","XL|virtual":"45364561739810","2XL|virtual":"45364561772578"}
};
var _hncSize={};
var _hncExp={};
function _hncGetVariant(key,handle){
  var m=HNC_VARIANTS[handle]; if(!m) return null;
  var sz=(_hncSize[key]||'L').toUpperCase();
  var ex=(_hncExp[key]||'physical');
  return (ex==='virtual' ? m[sz+'|virtual'] : null) || m[sz] || m['L'] || null;
}
function _hncQuickBuy(key,handle){
  var vid=_hncGetVariant(key,handle);
  if(!vid){ window.location.href='/products/'+handle; return; }
  var btn=document.querySelector('[data-quick-buy="'+key+'"]');
  if(btn){ btn.textContent='Adding...'; btn.style.opacity='0.7'; btn.style.pointerEvents='none'; }
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(){
      window.location.href='/cart';
    })
    .catch(function(){ window.location.href='/products/'+handle; });
}
// Event delegation for carousel interactions
document.addEventListener('click',function(e){
  // Size button on carousel card
  var sb=e.target.closest('.cc-sizes span');
  if(sb){
    var card=sb.closest('article[data-crate-key]');
    if(card){
      var k=card.getAttribute('data-crate-key');
      card.querySelectorAll('.cc-sizes span').forEach(function(s){s.classList.remove('on');});
      sb.classList.add('on');
      _hncSize[k]=sb.textContent.trim();
    }
  }
  // Exp toggle button
  var eb=e.target.closest('[data-exp-sel]');
  if(eb){
    var k=eb.getAttribute('data-crate-key');
    var card=eb.closest('article[data-crate-key]');
    if(card){ card.querySelectorAll('[data-exp-sel]').forEach(function(b){b.classList.remove('on');}); }
    eb.classList.add('on');
    _hncExp[k]=eb.getAttribute('data-exp-sel');
  }
  // Quick buy button
  var qb=e.target.closest('[data-quick-buy]');
  if(qb){
    e.preventDefault();
    _hncQuickBuy(qb.getAttribute('data-quick-buy'),qb.getAttribute('data-handle'));
  }
});
// ===== END QUICK BUY =====
var PAGE_HANDLE={"/crate-tshirt":"tee-crate","/crate-starter":"starter-crate","/crate-allstar":"all-star-crate","/crate-alltimegreat":"all-time-great-crate","/crate-goat":"goat-crate","/crate-megagoat":"mega-goat-crate"};
  function hncResolveVariant(handle, exp, size){
    var m=HNC_VARIANTS[handle]; if(!m) return null;
    var sz=(size||"").toUpperCase().replace("SMALL","S").replace("MEDIUM","M").replace("LARGE","L");
    var ex=(exp||"").toLowerCase().indexOf("virtual")>-1?"virtual":"physical";
    return m[sz+"|"+ex] || m[sz] || m["_default"] || null;
  }
  function hncDrawerOpen(){ var ov=document.getElementById("cartOv"),dr=document.getElementById("cartDrawer"); if(ov)ov.hidden=false; if(dr)dr.hidden=false; document.body.classList.add("cart-open"); if(window.__hncCartGame)try{window.__hncCartGame();}catch(_g){} }
  function hncRefreshDrawer(){
    fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(cart){
      var body=document.getElementById("cartBody"), totalEl=document.getElementById("cartTotal"), badge=document.getElementById("cartBadge");
      if(badge){ if(cart.item_count>0){badge.hidden=false;badge.textContent=cart.item_count;}else{badge.hidden=true;} }
      if(body){
        if(!cart.items.length){ body.innerHTML='<div class="cart-empty">Your crate is empty.<br>Add a drop to get started.</div>'; }
        else { body.innerHTML=cart.items.map(function(it){
          var opt=(it.variant_title||"").replace(" / "," · ");
          return '<div class="cart-item"><div class="cart-item-info"><b>'+it.product_title+'</b><span>'+opt+'</span><span>$'+(it.final_line_price/100).toFixed(0)+'</span></div><button type="button" class="cart-remove" data-remove="'+it.key+'" aria-label="Remove">&times;</button></div>';
        }).join(""); }
      }
      if(totalEl){ totalEl.textContent="$"+(cart.total_price/100).toFixed(0); }
    }).catch(function(){});
  }
  window.__hncAddToCart=function(handle,exp,size){
    var vid=hncResolveVariant(handle,exp,size);
    if(!vid){ window.location.href="/products/"+handle; return; }
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:vid,quantity:1})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ window.location.href="/cart"; })
      .catch(function(){ window.location.href="/products/"+handle; });
  };
  window.__hncRefreshDrawer=hncRefreshDrawer;
  window.__hncRemoveItem=function(key){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:0})})
      .then(function(r){return r.json();}).then(function(){ if(window.__hncRefreshDrawer)window.__hncRefreshDrawer(); }).catch(function(){});
  };
  // ---- single active discount (only ONE can be active at a time; first win locks it) ----
  window.__hncSetDiscount=function(code){
    try{ var cur=sessionStorage.getItem("hnc_active_discount"); if(cur) return cur; sessionStorage.setItem("hnc_active_discount",code); return code; }catch(e){ return code; }
  };
  window.__hncGetDiscount=function(){ try{ return sessionStorage.getItem("hnc_active_discount")||""; }catch(e){ return ""; } };
  window.__hncHasDiscount=function(){ return !!window.__hncGetDiscount(); };


  // ---- cart basketball mini-game (hard) ----
  function cartGame(){
    var cv=document.getElementById("cgCanvas"); if(!cv||cv.__init) return; cv.__init=true;
    var x=cv.getContext("2d"); var W=cv.width, H=cv.height;
    var shotsEl=document.getElementById("cgShots"), hintEl=document.getElementById("cgHint"), winEl=document.getElementById("cgWin"), resetBtn=document.getElementById("cgReset");
    var shots, ball, hoop, dragging, dragStart, flying, won, over;
    function reset(){ shots=3; won=false; over=false; flying=false; dragging=false; ball={x:W/2,y:H-26,r:11,vx:0,vy:0}; hoop={w:70,x:W/2-35,y:46,dir:1,speed:1.4}; if(shotsEl){shotsEl.textContent="Shots: 3";shotsEl.classList.remove("cg-lose");} if(winEl)winEl.hidden=true; if(resetBtn)resetBtn.hidden=true; if(hintEl){hintEl.hidden=false;hintEl.classList.remove("cg-lose");hintEl.textContent="Drag the ball back to aim, release to shoot the moving hoop";} }
    function resetBall(){ ball={x:W/2,y:H-26,r:11,vx:0,vy:0}; flying=false; }
    function moveHoop(){ hoop.x+=hoop.dir*hoop.speed; if(hoop.x<=6){hoop.x=6;hoop.dir=1;} if(hoop.x+hoop.w>=W-6){hoop.x=W-6-hoop.w;hoop.dir=-1;} }
    function draw(){ x.clearRect(0,0,W,H); x.fillStyle="rgba(255,255,255,.12)"; x.fillRect(hoop.x+hoop.w/2-22,hoop.y-30,44,22); x.strokeStyle="#FF5919"; x.lineWidth=4; x.beginPath(); x.ellipse(hoop.x+hoop.w/2,hoop.y,hoop.w/2,6,0,0,Math.PI*2); x.stroke(); x.strokeStyle="rgba(255,255,255,.25)"; x.lineWidth=1; for(var i=0;i<5;i++){var nx=hoop.x+4+i*(hoop.w-8)/4; x.beginPath(); x.moveTo(nx,hoop.y); x.lineTo(hoop.x+hoop.w/2,hoop.y+16); x.stroke();} if(dragging){ x.strokeStyle="rgba(255,255,255,.4)"; x.setLineDash([4,4]); x.lineWidth=2; x.beginPath(); x.moveTo(ball.x,ball.y); x.lineTo(dragStart.cx,dragStart.cy); x.stroke(); x.setLineDash([]); } x.fillStyle="#FF7A2E"; x.beginPath(); x.arc(ball.x,ball.y,ball.r,0,Math.PI*2); x.fill(); x.strokeStyle="rgba(0,0,0,.45)"; x.lineWidth=1.4; x.beginPath(); x.moveTo(ball.x-ball.r,ball.y); x.lineTo(ball.x+ball.r,ball.y); x.stroke(); x.beginPath(); x.moveTo(ball.x,ball.y-ball.r); x.lineTo(ball.x,ball.y+ball.r); x.stroke(); }
    function endShot(scored){ if(scored){ won=true; over=true; var applied=(window.__hncSetDiscount?window.__hncSetDiscount("HOOPS5"):"HOOPS5"); if(winEl){winEl.hidden=false; if(applied!=="HOOPS5"){winEl.innerHTML="Swish! But you already have a discount active (<b>"+applied+"</b>) — only one applies per order.";}} if(hintEl)hintEl.hidden=true; if(resetBtn)resetBtn.hidden=true; __hncLockHoop(); } else { shots--; if(shotsEl)shotsEl.textContent="Shots: "+shots; if(shots<=0){ over=true; if(hintEl){hintEl.classList.add("cg-lose");hintEl.textContent="That's your 3 shots for this order — better luck on your next crate!";} if(resetBtn)resetBtn.hidden=true; __hncLockHoop(); } resetBall(); } }
    function tick(){ if(!over) moveHoop(); if(flying){ ball.vy+=0.38; ball.x+=ball.vx; ball.y+=ball.vy; if(ball.vy>0 && ball.y>=hoop.y-6 && ball.y<=hoop.y+16){ if(ball.x>hoop.x+3 && ball.x<hoop.x+hoop.w-3){ endShot(true); } } if(ball.y>H+30 || ball.x<-30 || ball.x>W+30){ if(!won) endShot(false); } } draw(); requestAnimationFrame(tick); }
    function pos(e){ var r=cv.getBoundingClientRect(), t=(e.touches&&e.touches[0])||e; return {cx:(t.clientX-r.left)*(W/r.width), cy:(t.clientY-r.top)*(H/r.height)}; }
    function down(e){ if(over||flying) return; var p=pos(e); if(Math.hypot(p.cx-ball.x,p.cy-ball.y)<40){ dragging=true; dragStart=p; } }
    function move(e){ if(!dragging) return; e.preventDefault(); dragStart=pos(e); }
    function up(e){ if(!dragging) return; dragging=false; var p=dragStart; var dx=ball.x-p.cx, dy=ball.y-p.cy; if(Math.hypot(dx,dy)<8){ return; } flying=true; ball.vx=dx*0.16; ball.vy=dy*0.16; }
    cv.addEventListener("mousedown",down); window.addEventListener("mousemove",move); window.addEventListener("mouseup",up); cv.addEventListener("touchstart",down,{passive:false}); cv.addEventListener("touchmove",move,{passive:false}); cv.addEventListener("touchend",up); function __hncLockHoop(){ try{localStorage.setItem("hnc_hoop_played","1");}catch(e){} over=true; if(resetBtn)resetBtn.hidden=true; }
    function __hncHoopLocked(){ try{return localStorage.getItem("hnc_hoop_played")==="1";}catch(e){return false;} }
    function __hncShowLocked(){ over=true; flying=false; dragging=false; if(shotsEl){shotsEl.textContent="Shots: 0";shotsEl.classList.add("cg-lose");} if(resetBtn)resetBtn.hidden=true; if(winEl)winEl.hidden=true; if(hintEl){hintEl.hidden=false;hintEl.classList.add("cg-lose");hintEl.textContent="You've used your 3 shots for this order. Come back with your next crate!";} }
    if(resetBtn)resetBtn.hidden=true; reset(); if(__hncHoopLocked()){ __hncShowLocked(); } tick();
  }

  window.__hncCartGame=cartGame;
  // ==== RESILIENT GLOBAL CLICK SHIM (attaches first, never depends on other init) ====
  try{
    document.addEventListener("click", function(e){
      // 1) Buy links / sticky bar -> navigate to Shopify product (works even if cart() failed)
      var buy=e.target.closest('a[data-buy], a#psbAdd, [data-shop]');
      if(buy){
        e.preventDefault();
        try{
          var page=buy.closest('.page')||document;
          var route=(page.getAttribute&&page.getAttribute('data-route'))||'';
          var handle=PAGE_HANDLE[route];
          if(!handle){ var hh=buy.getAttribute('href')||buy.getAttribute('data-shop')||''; var mm=hh.match(/products\/([^?]+)/); if(mm) handle=mm[1]; }
          var expEl=page.querySelector('.exp-card.on b'); var exp=expEl?expEl.textContent.trim():'';
          var sizeEl=page.querySelector('[data-sizes] span.on'); var size=sizeEl?sizeEl.textContent.trim():'';
          if(handle && window.__hncAddToCart){ window.__hncAddToCart(handle, exp, size); return; }
          var fb=buy.getAttribute('href')||buy.getAttribute('data-shop'); if(fb && fb!=='#'){ window.location.href=fb; }
        }catch(_x){ var fb2=buy.getAttribute('href')||buy.getAttribute('data-shop'); if(fb2 && fb2!=='#') window.location.href=fb2; }
        return;
      }
      // 2) Hash nav links -> let native anchor set hash; router listens to hashchange
      var nav=e.target.closest('a[href^="#/"]');
      if(nav){ var target=nav.getAttribute('href'); e.preventDefault();
        var h=target.replace('#','');
        if(location.hash===target || location.hash==='#'+h){ if(window.__hncGo) try{window.__hncGo();}catch(_){} }
        else { location.hash=target; }
        return; }
    }, false);
  }catch(_e){}
  var LOGO="https://d2ol7oe51mr4n9.cloudfront.net/user_3EXeV5ruZ4eqaBppGKeAzGhuOHt/1d43d977-2b4e-4ac7-8e23-da0223b0c2fb.webp";
  // ---- hash router ----
  function routes(){return Array.prototype.slice.call(document.querySelectorAll('.page'));}
  var PATH_ROUTE={'crate-tshirt':'/crate-tshirt','crate-starter':'/crate-starter','crate-allstar':'/crate-allstar','crate-alltimegreat':'/crate-alltimegreat','crate-goat':'/crate-goat','crate-megagoat':'/crate-megagoat','crates':'/crates','rarity':'/rarity','react':'/react','spin':'/spin'};
  function pathRoute(){
    var m=location.pathname.match(/^\/pages\/([a-z0-9-]+)\/?$/);
    return (m && PATH_ROUTE[m[1]]) || null;
  }
  function go(){
    var h=(location.hash||'#/').replace('#','');
    if(h==='/'&&!location.hash){ var pr=pathRoute(); if(pr){ h=pr; } }
    if(h==='/crates'){ show('/'); setTimeout(function(){var a=document.getElementById('crates-anchor'); if(a)a.scrollIntoView({behavior:'smooth'});},60); return; }
    show(h);
  }
  var PRODMAP={'/crate-tshirt':['Rookie Crate','79'],'/crate-starter':['Starter Crate','189'],'/crate-allstar':['All Star Crate','225'],'/crate-alltimegreat':['All Time Great','319'],'/crate-goat':['GOAT Crate','399'],'/crate-megagoat':['Mega GOAT','649']};var PSB_H={"/crate-tshirt":"tee-crate","/crate-starter":"starter-crate","/crate-allstar":"all-star-crate","/crate-alltimegreat":"all-time-great-crate","/crate-goat":"goat-crate","/crate-megagoat":"mega-goat-crate"};function syncStickybar(path){var bar=document.getElementById('prodStickybar'),pr=document.getElementById('psbPrice'),ab=document.getElementById('psbAdd');var d=PRODMAP[path];if(d){document.body.classList.add('on-product');if(pr)pr.textContent='$'+d[1];if(ab){ab.setAttribute('data-name',d[0]);ab.setAttribute('data-price',d[1]);ab.textContent='Get '+d[0]+' — $'+d[1];var hh=PSB_H[path];if(hh){ab.setAttribute('href','/products/'+hh);}}}else{document.body.classList.remove('on-product');}}
  function show(path){
    syncStickybar(path);
    var found=false;
    routes().forEach(function(p){
      var on=p.getAttribute('data-route')===path;
      p.classList.toggle('active',on);
      if(on)found=true;
    });
    if(!found){ routes().forEach(function(p){p.classList.toggle('active',p.getAttribute('data-route')==='/');}); }
    document.querySelectorAll('.nav-links a').forEach(function(a){
      a.classList.toggle('active', a.getAttribute('href')==='#'+path);
    });
    var nl=document.getElementById('navLinks'); if(nl)nl.classList.remove('open');
    window.scrollTo(0,0);
    revealScan();
  }
  try{window.__hncGo=go;}catch(_){} window.addEventListener('hashchange',go);

  // ---- scroll reveal (brand easing) ----
  var io;
  function revealScan(){
    document.querySelectorAll('[data-sr-stagger]').forEach(function(p){
      var step=parseInt(p.getAttribute('data-sr-stagger'),10)||80;
      Array.prototype.forEach.call(p.children,function(c,i){c.style.transitionDelay=(i*step)+'ms';});
    });
    var els=document.querySelectorAll('.page.active .sr, .page.active [data-sr-stagger]');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('show');});return;}
    if(!io){io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('show');io.unobserve(e.target);}});},{threshold:0.14,rootMargin:'0px 0px -8% 0px'});}
    els.forEach(function(e){ if(!e.classList.contains('show')) io.observe(e); });
  }

  // ---- nav burger ----
  var burger=document.getElementById('navBurger');
  if(burger)burger.addEventListener('click',function(){document.getElementById('navLinks').classList.toggle('open');});

  // ---- FAQ + crate pull accordions are native <details>; pull buttons toggle text ----
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-acc]'); if(b){ b.classList.toggle('open'); }
  });

  // ---- Plinko game ----
  (function(){
    var cv=document.getElementById('plinko'); if(!cv)return;
    var ctx=cv.getContext('2d'); var W=cv.width,H=cv.height;
    var ROWS=5, slots=6, drops=1, running=false;
    var SLOT_COLORS=['#F26522','#3a7bd5','#caa24a','#2e9e6b','#7b59c9','#e08a4a'];
    var SLOT_NAMES=['Crate Respin','Free Tee','Mystery Crate','Jersey Pull','Snapback Hat','5% OFF CODE'];
    // build pegs (pyramid)
    var pegs=[], topY=70, botY=H-130, gapY=(botY-topY)/(ROWS-1);
    for(var r=0;r<ROWS;r++){
      var count=r+3, spread=Math.min(W-120,60*(count));
      var y=topY+r*gapY, startX=W/2-spread/2;
      for(var c=0;c<count;c++){ pegs.push({x:startX+(spread/(count-1))*c, y:y, r:5}); }
    }
    var ball=null, slotY=H-70;
    function draw(){
      ctx.clearRect(0,0,W,H);
      // guide line
      ctx.strokeStyle='rgba(255,255,255,.12)';ctx.setLineDash([4,6]);ctx.beginPath();ctx.moveTo(W/2,10);ctx.lineTo(W/2,55);ctx.stroke();ctx.setLineDash([]);
      // pegs
      for(var i=0;i<pegs.length;i++){var p=pegs[i];ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,7);ctx.fillStyle='#fff';ctx.fill();}
      // ball
      if(ball){
        ctx.save();ctx.shadowColor='#F26522';ctx.shadowBlur=18;
        ctx.beginPath();ctx.arc(ball.x,ball.y,9,0,7);ctx.fillStyle='#F26522';ctx.fill();ctx.restore();
      }
    }
    function reset(){ ball=null; draw(); }
    reset();
    function drop(){
      if(running||drops<=0)return; running=true; drops--; var dc=document.getElementById('dropCount'); if(dc)dc.textContent=drops;
      var btn=document.getElementById('dropBtn'); if(btn){btn.disabled=true;}
      document.querySelectorAll('.pslot').forEach(function(s){s.classList.remove('win');});
      var res=document.getElementById('plinkoResult'); if(res){res.hidden=true;}
      // weighted outcome: idx 0 Code,1 Tee,2 Crate,3 Jersey,4 Hat,5 Off
      var WEIGHTS=[23,3,0,1,3,70];
      var totalW=WEIGHTS.reduce(function(a,b){return a+b;},0), rnd=Math.random()*totalW, acc=0, pick=0;
      for(var wi=0;wi<WEIGHTS.length;wi++){acc+=WEIGHTS[wi]; if(rnd<=acc){pick=wi;break;}}
      window.__plinkoTarget=pick;
      var targetX=(pick+0.5)*(W/slots);
      window.__plinkoTargetX=targetX;
      ball={x:W/2+(Math.random()*8-4), y:40, vx:0, vy:0};
      function step(){
        ball.vy+=0.07; if(ball.vy>2.4)ball.vy=2.4; ball.y+=ball.vy; ball.x+=ball.vx; ball.vx*=0.99;
        // subtle steering toward weighted target (stronger as it nears the bottom)
        var tx=window.__plinkoTargetX; if(typeof tx==='number'){ var prog=Math.min(ball.y/slotY,1); ball.vx+=((tx-ball.x)*0.0011*(0.5+prog)); if(prog>0.85){ ball.x+=(tx-ball.x)*0.10; ball.vx*=0.7; } }
        for(var i=0;i<pegs.length;i++){var p=pegs[i];var dx=ball.x-p.x,dy=ball.y-p.y;var d=Math.hypot(dx,dy);
          if(d<p.r+9){ var ang=Math.atan2(dy,dx); ball.x=p.x+Math.cos(ang)*(p.r+9); ball.y=p.y+Math.sin(ang)*(p.r+9);
            ball.vx=Math.cos(ang)*1.0+(Math.random()*0.6-0.3); ball.vy=Math.abs(ball.vy)*0.45+0.20; }
        }
        if(ball.x<14){ball.x=14;ball.vx*=-0.6;} if(ball.x>W-14){ball.x=W-14;ball.vx*=-0.6;}
        draw();
        if(ball.y>=slotY){ land(); return; }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function land(){
      var tIdx=(typeof window.__plinkoTarget==='number')?window.__plinkoTarget:0; ball.x=(tIdx+0.5)*(W/slots); draw(); var idx=Math.max(0,Math.min(slots-1,Math.floor(ball.x/(W/slots))));
      var cells=document.querySelectorAll('.pslot'); if(cells[idx])cells[idx].classList.add('win');
      var res=document.getElementById('plinkoResult'); if(res){res.hidden=false;var label=SLOT_NAMES[idx];if(/5% OFF/i.test(label)){var ap=(window.__hncSetDiscount?window.__hncSetDiscount('HOOPS5'):'HOOPS5');if(ap==='HOOPS5'){res.textContent='You won: 5% OFF! Code HOOPS5 applies at checkout.';}else{res.textContent='You won 5% OFF, but you already have '+ap+' active — only one discount per order.';}}else if(/respin/i.test(label)){var rc=__hncIssueRespinCode();res.innerHTML='You won a <b>CRATE RESPIN</b>! Your code: <b class="rs-code">'+rc+'</b><br><span style="font-size:13px;opacity:.85">Saved to this device. Use it on the Respin page — one-time use.</span><br><a class="btn btn-primary" style="margin-top:10px;display:inline-block" href="/pages/respin" target="_top">Use Respin Now</a>';}else if(/tee/i.test(label)){var code=__hncIssuePlinkoItemCode('FREETSHIRT');res.innerHTML='You won a <b>FREE TEE</b>! Your code: <b class="rs-code">'+code+'</b><br><span style="font-size:13px;opacity:.85">Copy this code and apply it at checkout (valid only as an add-on when purchasing another crate).</span>';}else if(/hat/i.test(label)){var code=__hncIssuePlinkoItemCode('FREEHAT');res.innerHTML='You won a <b>SNAPBACK HAT</b>! Your code: <b class="rs-code">'+code+'</b><br><span style="font-size:13px;opacity:.85">Copy this code and apply it at checkout (valid only as an add-on when purchasing another crate).</span>';}else if(/jersey/i.test(label)){var code=__hncIssuePlinkoItemCode('FREEJSY');res.innerHTML='You won a <b>FREE JERSEY</b>! Your code: <b class="rs-code">'+code+'</b><br><span style="font-size:13px;opacity:.85">Copy this code and apply it at checkout (valid only as an add-on when purchasing another crate).</span>';}else if(/mystery/i.test(label)){var code=__hncIssuePlinkoItemCode('MYSTERY');res.innerHTML='You won a <b>MYSTERY CRATE</b>! Your code: <b class="rs-code">'+code+'</b><br><span style="font-size:13px;opacity:.85">Copy this code and apply it at checkout (valid only as an add-on when purchasing another crate).</span>';}else{res.textContent='You won: '+label+'!';}}
      running=false;
      var btn=document.getElementById('dropBtn');
      if(btn){ if(drops<=0){btn.textContent='NO DROPS LEFT';} else {btn.disabled=false;} }
    }
    
    // ---- respin code issuance (client-side; one-time use, validated on respin page) ----
    function __hncIssueRespinCode(){
      var code='RS-'+Math.random().toString(36).slice(2,8).toUpperCase();
      try{
        var raw=localStorage.getItem('hnc_respin_codes'); var map=raw?JSON.parse(raw):{};
        map[code]={issued:Date.now(),used:false,source:'plinko'};
        localStorage.setItem('hnc_respin_codes',JSON.stringify(map));
      }catch(e){}
      return code;
    }

    // ---- plinko item code issuance ----
    function __hncIssuePlinkoItemCode(prefix){
      if (prefix === 'FREEHAT' || prefix === 'FREETSHIRT' || prefix === 'FREEGOAT') {
        return prefix;
      }
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      var c = '';
      for (var i = 0; i < 6; i++) c += chars[Math.floor(Math.random() * chars.length)];
      var code = prefix + '-' + c;
      try{
        var raw=localStorage.getItem('hnc_won_items'); var map=raw?JSON.parse(raw):{};
        map[code]={issued:Date.now(),used:false};
        localStorage.setItem('hnc_won_items',JSON.stringify(map));
      }catch(e){}
      return code;
    }
    // ---- code gate (order-derived validation) ----
    var MASTER='HNCMASTER00';  // owner override for testing
    var gate=document.getElementById('plinkoGate'), game=document.getElementById('plinkoGame');
    var pgIn=document.getElementById('pgInput'), pgBtn=document.getElementById('pgBtn'), pgErr=document.getElementById('pgErr');
    function unlock(){ if(gate)gate.classList.add('plinko-hidden'); if(game)game.classList.remove('plinko-hidden'); var b=document.getElementById('dropBtn'); if(b)b.classList.remove('plinko-hidden'); var r=document.getElementById('plinkoResult'); if(r)r.classList.remove('plinko-hidden'); try{sessionStorage.setItem('hnc_plinko_unlocked','1');}catch(e){} }
    function __hncCodeUsed(c){ try{var m=JSON.parse(localStorage.getItem('hnc_used_plinko_codes')||'{}');return !!m[c];}catch(e){return false;} }
    function __hncMarkCodeUsed(c){ try{var m=JSON.parse(localStorage.getItem('hnc_used_plinko_codes')||'{}');m[c]=Date.now();localStorage.setItem('hnc_used_plinko_codes',JSON.stringify(m));}catch(e){} }
    // Self-validating order code: HNC + 6 digit body + 2 checksum letters
    function __hncValidCode(code){
      code=(code||'').trim().toUpperCase().replace(/[-\s]/g,'');
      if(code.indexOf('HNC')!==0||code.length!==11)return false;
      var body=code.slice(3,9);
      if(!/^[0-9]{6}$/.test(body))return false;
      var s=0,w=0;
      for(var i=0;i<6;i++){var d=+body.charAt(i);s+=d;w+=d*(i+1);}
      var c1=String.fromCharCode(65+((s*7+3)%26));
      var c2=String.fromCharCode(65+((w*5+11)%26));
      return code.charAt(9)===c1&&code.charAt(10)===c2;
    }
    function tryCode(){ var v=(pgIn?pgIn.value:'').trim().toUpperCase().replace(/[-\s]/g,''); if(!v){ if(pgErr){pgErr.hidden=false;pgErr.textContent="Enter your drop code.";} return; }
      if(v===MASTER){ if(pgErr)pgErr.hidden=true; unlock(); return; }
      if(!__hncValidCode(v)){ if(pgErr){pgErr.hidden=false;pgErr.textContent="That code isn't valid. Check your order confirmation email.";} return; }
      if(__hncCodeUsed(v)){ if(pgErr){pgErr.hidden=false;pgErr.textContent="That code has already been used. Each order unlocks one drop.";} return; }
      if(pgErr)pgErr.hidden=true; __hncMarkCodeUsed(v); unlock();
    }
    if(pgBtn)pgBtn.addEventListener('click',tryCode);
    if(pgIn)pgIn.addEventListener('keypress',function(e){ if(e.key==='Enter')tryCode(); });
    try{ if(sessionStorage.getItem('hnc_plinko_unlocked')==='1')unlock(); }catch(e){}
    
    var db=document.getElementById('dropBtn'); if(db)db.addEventListener('click',drop);
  })();
  // ---- sticky mobile CTA ----
  var bar=document.querySelector('.sticky-cta');
  if(bar){document.body.classList.add('has-sticky');
    window.addEventListener('scroll',function(){ if(window.scrollY>600)bar.classList.add('is-on'); else bar.classList.remove('is-on'); },{passive:true});}

  // ---- count-up stats ----
  function runCount(el){
    el.querySelectorAll('[data-count]').forEach(function(b){
      var target=parseFloat(b.getAttribute('data-count'));
      var dec=parseInt(b.getAttribute('data-dec')||'0',10);
      var suf=b.getAttribute('data-suffix')||'';
      var dur=1500,start=performance.now();
      (function tick(now){
        var t=Math.min((now-start)/dur,1);
        var e=1-Math.pow(1-t,3);
        var v=(target*e);
        b.textContent=(dec>0?v.toFixed(dec):Math.round(v).toLocaleString())+suf;
        if(t<1)requestAnimationFrame(tick);
        else b.textContent=(dec>0?target.toFixed(dec):Math.round(target).toLocaleString())+suf;
      })(start);
    });
  }
  var statObs=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){runCount(e.target);statObs.unobserve(e.target);}});},{threshold:0.4});
  var sg=document.querySelector('[data-stats]'); if(sg)statObs.observe(sg);
    // ---- smooth continuous jersey reveal (sticky + lerp scrub) ----
  (function(){
    var sec=document.getElementById('revealScrub'),v=document.getElementById('rsVideo');
    var dots=document.getElementById('rsDots'),hint=document.getElementById('rsHint');
    if(!sec||!v)return;
    var HI='https://d2ol7oe51mr4n9.cloudfront.net/user_3EXeV5ruZ4eqaBppGKeAzGhuOHt/1d4df3eb-e39f-4bd0-89c7-8bc873104c65.mp4';
    var LO='https://d2ol7oe51mr4n9.cloudfront.net/user_3EXeV5ruZ4eqaBppGKeAzGhuOHt/5f1f4eef-8b07-4571-b980-0ca831042913.mp4';
    var small=(window.matchMedia('(max-width:760px)').matches||(navigator.connection&&navigator.connection.saveData));
    v.src=small?LO:HI; v.muted=true; v.playsInline=true; v.setAttribute('playsinline','');
    // jersey peak times -> light the dots as the playhead passes them
    var MARKS=[0.20,2.40,3.05,4.05,5.05,5.55];
    var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
    var dur=5.6, ready=false, target=0, current=0, raf=null, active=false;
    var di=dots?dots.querySelectorAll('i'):[];
    function paintFor(t){ var step=0; for(var k=0;k<MARKS.length;k++){ if(t>=MARKS[k]-0.05) step=k; } for(var j=0;j<di.length;j++){ di[j].className=(j<=step?'on':''); } if(hint){ t>MARKS[1]?hint.classList.add('hide'):hint.classList.remove('hide'); } }
    v.addEventListener('loadedmetadata',function(){ dur=v.duration||5.6; ready=true; current=v.currentTime||0; });
    v.load();

    if(reduce){
      var io2=new IntersectionObserver(function(en){en.forEach(function(e){ if(e.isIntersecting){ try{v.currentTime=0;}catch(e){} v.play().catch(function(){}); } });},{threshold:.4});
      io2.observe(sec); return;
    }

    function progress(){
      var r=sec.getBoundingClientRect();
      var total=sec.offsetHeight-window.innerHeight;
      return Math.min(Math.max(-r.top/total,0),1); // 0..1 continuous
    }
    var lastSeek=-1;
    function loop(){
      // ease the playhead toward the scroll target
      current += (target-current)*0.15;
      var settled = Math.abs(target-current) < 0.01;
      // only seek when NOT already seeking (avoids queueing expensive overlapping seeks -> the main cause of jank)
      // and quantise to ~1/12s steps so tiny scroll deltas don't trigger a fresh decode every frame
      if(ready && !v.seeking){
        var q = Math.round(current*12)/12;
        if(q !== lastSeek){
          lastSeek = q;
          try{ v.currentTime = Math.min(Math.max(q,0),dur); }catch(e){}
          paintFor(current);
        }
      }
      // keep looping while actively scrubbing; stop the rAF once the playhead settles to save CPU
      if(active && !settled){ raf=requestAnimationFrame(loop); } else { raf=null; }
    }
    function setTarget(){ target=progress()*dur; if(active && !raf){ raf=requestAnimationFrame(loop); } }
    var io=new IntersectionObserver(function(en){en.forEach(function(e){
      if(e.isIntersecting){ active=true; setTarget(); if(!raf) raf=requestAnimationFrame(loop); }
      else { active=false; }
    });},{threshold:0});
    io.observe(sec);
    window.addEventListener('scroll',function(){ if(active) setTarget(); },{passive:true});
    window.addEventListener('resize',function(){ if(active) setTarget(); },{passive:true});
  })();

    // ---- crate carousel arrows ----
  function crateCar(){
    var t=document.getElementById('crateTrack'); if(!t)return;
    function step(){var c=t.querySelector('.cc');return c?c.getBoundingClientRect().width+18:340;}
    var p=document.querySelector('[data-cc-prev]'),n=document.querySelector('[data-cc-next]');
    if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'});});
    if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'});});
  }
  try{crateCar();}catch(_e){if(window.console)console.warn("init fail:crateCar",_e);}
  function rxCar(){
    var t=document.getElementById('rxTrack'); if(!t)return;
    function step(){var c=t.querySelector('.rx');return c?c.getBoundingClientRect().width+18:340;}
    var p=document.querySelector('[data-rx-prev]'),n=document.querySelector('[data-rx-next]');
    if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'});});
    if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'});});
  }
  try{rxCar();}catch(_e){if(window.console)console.warn("init fail:rxCar",_e);}
  function rxCar2(){
    var t=document.getElementById('rxTrack2'); if(!t)return;
    function step(){var c=t.querySelector('.rx');return c?c.getBoundingClientRect().width+18:340;}
    var p=document.querySelector('[data-rx2-prev]'),n=document.querySelector('[data-rx2-next]');
    if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'});});
    if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'});});
  }
  try{rxCar2();}catch(_e){if(window.console)console.warn("init fail:rxCar2",_e);}
  function prodOpts(){
    document.querySelectorAll('[data-exp]').forEach(function(c){
      c.addEventListener('click',function(){
        var g=c.parentNode; g.querySelectorAll('.exp-card').forEach(function(x){x.classList.remove('on');});
        c.classList.add('on');
      });
    });
    document.querySelectorAll('[data-sizes]').forEach(function(g){
      g.querySelectorAll('span').forEach(function(sp){
        sp.addEventListener('click',function(){ g.querySelectorAll('span').forEach(function(x){x.classList.remove('on');}); sp.classList.add('on'); });
      });
    });
    var sgOverlay=document.getElementById('sgOverlay'),sgClose=document.getElementById('sgClose');
    function openSG(){if(sgOverlay){sgOverlay.hidden=false;document.body.style.overflow='hidden';}}
    function closeSG(){if(sgOverlay){sgOverlay.hidden=true;document.body.style.overflow='';}}
    document.querySelectorAll('[data-size-guide]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openSG();});});
    if(sgClose)sgClose.addEventListener('click',closeSG);
    if(sgOverlay)sgOverlay.addEventListener('click',function(e){if(e.target===sgOverlay)closeSG();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeSG();});
    // ---- review carousels (event delegation — works across SPA routes) ----
    function initCarousel(rc){
      if(rc._rcrInit)return; rc._rcrInit=true;
      var slides=rc.querySelectorAll('.rcr-slide,.prc-slide');
      var dots=rc.querySelectorAll('.rcr-dot');
      var cur=0;
      function go(n){
        slides[cur].classList.remove('active');
        if(dots[cur])dots[cur].classList.remove('on');
        cur=(n+slides.length)%slides.length;
        slides[cur].classList.add('active');
        if(dots[cur])dots[cur].classList.add('on');
      }
      var prev=rc.querySelector('[data-rcr-prev]');
      var next=rc.querySelector('[data-rcr-next]');
      if(prev)prev.addEventListener('click',function(e){e.stopPropagation();go(cur-1);});
      if(next)next.addEventListener('click',function(e){e.stopPropagation();go(cur+1);});
      dots.forEach(function(d,i){d.addEventListener('click',function(e){e.stopPropagation();go(i);});});
    }
    function initAllCarousels(){
      document.querySelectorAll('[data-rcr]').forEach(initCarousel);
    }
    // ---- swipe image galleries (native touch scroll-snap, e.g. product photos) ----
    function initSwipeGal(el){
      if(el._swipeInit)return; el._swipeInit=true;
      var track=el.querySelector('.swipe-track');
      var slides=track.children;
      var dots=el.querySelectorAll('.rcr-dot');
      var hint=el.querySelector('.swipe-hint');
      var hintDismissed=false;
      function dismissHint(){
        if(hintDismissed||!hint)return; hintDismissed=true;
        hint.style.transition='opacity .3s ease';
        hint.style.opacity='0';
        setTimeout(function(){if(hint)hint.style.display='none';},320);
      }
      track.addEventListener('touchstart',dismissHint,{passive:true,once:true});
      track.addEventListener('scroll',dismissHint,{passive:true,once:true});
      var cur=0, tId;
      function setDot(i){
        if(dots[cur])dots[cur].classList.remove('on');
        cur=i;
        if(dots[cur])dots[cur].classList.add('on');
      }
      function slideCenter(i){
        var s=slides[i];
        return s.offsetLeft+s.offsetWidth/2;
      }
      function goTo(i){
        i=(i+slides.length)%slides.length;
        track.scrollTo({left:slideCenter(i)-track.clientWidth/2,behavior:'smooth'});
        setDot(i);
      }
      var prev=el.querySelector('[data-rcr-prev]');
      var next=el.querySelector('[data-rcr-next]');
      if(prev)prev.addEventListener('click',function(e){e.stopPropagation();goTo(cur-1);});
      if(next)next.addEventListener('click',function(e){e.stopPropagation();goTo(cur+1);});
      dots.forEach(function(d,i){d.addEventListener('click',function(e){e.stopPropagation();goTo(i);});});
      track.addEventListener('scroll',function(){
        clearTimeout(tId);
        tId=setTimeout(function(){
          var mid=track.scrollLeft+track.clientWidth/2, best=0, bestDist=Infinity;
          for(var i=0;i<slides.length;i++){
            var d=Math.abs(slideCenter(i)-mid);
            if(d<bestDist){bestDist=d;best=i;}
          }
          setDot(best);
        },80);
      },{passive:true});
    }
    function initAllSwipeGals(){
      document.querySelectorAll('[data-swipe]').forEach(initSwipeGal);
    }
    initAllCarousels();
    initAllSwipeGals();
    // Re-init on SPA route changes
    document.addEventListener('click',function(){setTimeout(function(){initAllCarousels();initAllSwipeGals();},50);});
    var REVEAL_URL='https://d2ol7oe51mr4n9.cloudfront.net/user_3EXeV5ruZ4eqaBppGKeAzGhuOHt/327ad669-02c2-40d2-ac40-13b23d3dd0d6.html';
    var ov=document.getElementById('revealOv'), ifr=document.getElementById('revealFrame'), ovx=document.getElementById('revealX');
    function openReveal(slug){ if(!ov||!ifr)return; ifr.src=REVEAL_URL+'?crate='+encodeURIComponent(slug||'goat'); ov.hidden=false; document.body.style.overflow='hidden'; document.body.classList.add('reveal-open'); }
    function closeReveal(){ if(!ov||!ifr)return; ov.hidden=true; ifr.src='about:blank'; document.body.style.overflow=''; document.body.classList.remove('reveal-open'); }
    document.querySelectorAll('[data-preview]').forEach(function(b){ b.addEventListener('click',function(){ openReveal(b.getAttribute('data-crate')); }); });
    if(ovx)ovx.addEventListener('click',closeReveal);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && ov && !ov.hidden)closeReveal(); });
  }
  try{prodOpts();}catch(_e){if(window.console)console.warn("init fail:prodOpts",_e);}
  function teamTheme(){
    var root=document.documentElement, ov=document.getElementById('ttOverlay');
    var openB=document.getElementById('ttOpen'), closeB=document.getElementById('ttClose');
    var resetB=document.getElementById('ttReset');
    var DEF={pri:'#F26522',dk:'#D35400',acc:'#FFC23C'}; try{localStorage.removeItem('hnc_theme');}catch(e){}
    function hexToRgb(h){h=h.replace('#','');if(h.length===3)h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];var n=parseInt(h,16);return[(n>>16)&255,(n>>8)&255,n&255];}
    function lighten(h,p){var c=hexToRgb(h);return'rgb('+c.map(function(v){return Math.round(v+(255-v)*p);}).join(',')+')';}
    function darken(h,p){var c=hexToRgb(h);return'rgb('+c.map(function(v){return Math.round(v*(1-p));}).join(',')+')';}
    function apply(t){
      root.style.setProperty('--orange',t.pri);
      root.style.setProperty('--orange-d',t.dk);
      root.style.setProperty('--gold',t.acc);
      root.style.setProperty('--accent-lite',lighten(t.pri,0.22));
      root.style.setProperty('--accent-shadow',darken(t.pri,0.45));
      root.style.setProperty('--accent-rgb',hexToRgb(t.pri).join(','));
    }
    function save(t){ /* per-session only; not persisted so site always loads default orange */ }
    function open(){ if(ov){ov.hidden=false;} var nl=document.getElementById('navLinks'); if(nl)nl.classList.remove('open'); }
    function close(){ if(ov){ov.hidden=true;} }
    if(openB){ openB.addEventListener('click',open); openB.addEventListener('keypress',function(e){if(e.key==='Enter')open();}); }
    if(closeB)closeB.addEventListener('click',close);
    if(ov)ov.addEventListener('click',function(e){ if(e.target===ov)close(); });
    document.querySelectorAll('.tt-card').forEach(function(c){
      c.addEventListener('click',function(){
        var t={pri:c.getAttribute('data-pri'),dk:c.getAttribute('data-dk'),acc:c.getAttribute('data-acc'),name:c.getAttribute('data-name')};
        apply(t); save(t);
        document.querySelectorAll('.tt-card').forEach(function(x){x.classList.remove('on');});
        c.classList.add('on'); close();
      });
    });
    if(resetB)resetB.addEventListener('click',function(){ apply(DEF); try{localStorage.removeItem('hnc_theme');}catch(e){} document.querySelectorAll('.tt-card').forEach(function(x){x.classList.remove('on');}); close(); });
    // intentionally NOT restoring saved theme — site always loads on default orange
  }
  try{teamTheme();}catch(_e){if(window.console)console.warn("init fail:teamTheme",_e);}
  function dropCountdown(){var el=document.getElementById('dropCountdown'); if(!el)return; var target=new Date(el.getAttribute('data-target')).getTime(); function pad(n){return (n<10?'0':'')+n;} function tick(){var diff=target-Date.now(); if(diff<=0){el.textContent='LIVE NOW';return;} var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s2=Math.floor(diff%6e4/1e3); el.textContent=d+'d : '+pad(h)+'h : '+pad(m)+'m : '+pad(s2)+'s';} tick(); setInterval(tick,1000);} dropCountdown();
  function cart(){var KEY="hnc_cart";var ov=document.getElementById("cartOv"),dr=document.getElementById("cartDrawer"),body=document.getElementById("cartBody");var badge=document.getElementById("cartBadge"),totalEl=document.getElementById("cartTotal");function load(){try{return JSON.parse(localStorage.getItem(KEY)||"[]");}catch(e){return [];}}function save(c){try{localStorage.setItem(KEY,JSON.stringify(c));}catch(e){}}function add(name,price){var c=load();var f=c.find(function(x){return x.name===name;});if(f){f.qty++;}else{c.push({name:name,price:+price,qty:1});}save(c);render();open();}function setQty(name,d){var c=load();var f=c.find(function(x){return x.name===name;});if(!f)return;f.qty+=d;if(f.qty<=0){c=c.filter(function(x){return x.name!==name;});}save(c);render();}function count(){return load().reduce(function(a,b){return a+b.qty;},0);}function total(){return load().reduce(function(a,b){return a+b.price*b.qty;},0);}function render(){var c=load();var n=count();if(badge){if(n>0){badge.hidden=false;badge.textContent=n;}else{badge.hidden=true;}}if(!body)return;if(!c.length){body.innerHTML="<div class=\"cart-empty\">Your crate is empty.<br>Add a drop to get started.</div>";}else{body.innerHTML=c.map(function(it){return "<div class=\"cart-item\"><div class=\"cart-item-info\"><b>"+it.name+"</b><span>$"+it.price+"</span></div><div class=\"cart-qty\"><button data-dec=\""+it.name+"\">−</button><span>"+it.qty+"</span><button data-inc=\""+it.name+"\">+</button></div></div>";}).join("");}if(totalEl)totalEl.textContent="$"+total();var nd=document.getElementById('cartNudge');if(nd){var t=total();var FREE=200;if(t<=0){nd.hidden=true;}else if(t<FREE){nd.hidden=false;nd.textContent="You're $"+(FREE-t)+" away from FREE express shipping";}else{nd.hidden=false;nd.textContent="✓ You've unlocked FREE express shipping!";}}}function open(){if(ov)ov.hidden=false;if(dr)dr.hidden=false;document.body.style.overflow="hidden";document.body.classList.add("cart-open");}function close(){if(ov)ov.hidden=true;if(dr)dr.hidden=true;document.body.style.overflow="";document.body.classList.remove("cart-open");}document.addEventListener("click",function(e){var SHOP={"Rookie Crate":"tee-crate","Starter Crate":"starter-crate","All Star Crate":"all-star-crate","All Time Great":"all-time-great-crate","GOAT Crate":"goat-crate","Mega GOAT":"mega-goat-crate"};var SHOPBASE="/products/";var a=e.target.closest("[data-add]");if(a){var sn=a.getAttribute("data-name");var url=a.getAttribute("data-shop")||(SHOP[sn]?SHOPBASE+SHOP[sn]:null);if(url){window.location.href=url;return;}add(sn,a.getAttribute("data-price"));return;}var rm=e.target.closest("[data-remove]"); if(rm){ e.preventDefault(); if(window.__hncRemoveItem)window.__hncRemoveItem(rm.getAttribute("data-remove")); return; }if(e.target.closest("#navCart")){if(window.__hncRefreshDrawer)window.__hncRefreshDrawer();open();if(window.__hncCartGame)try{window.__hncCartGame();}catch(_g){}return;}if(e.target.closest("#cartX")||e.target===ov){close();return;}var inc=e.target.closest("[data-inc]");if(inc){setQty(inc.getAttribute("data-inc"),1);return;}var dec=e.target.closest("[data-dec]");if(dec){setQty(dec.getAttribute("data-dec"),-1);return;}if(e.target.closest("#cartCheckout")){e.preventDefault();var dc=(window.__hncGetDiscount?window.__hncGetDiscount():"");if(dc){window.location.href="/discount/"+dc+"?redirect=/cart";}else{window.location.href="/cart";}return;}});render();}cart();
  function giftCard(){var sel=79;document.querySelectorAll("[data-gc]").forEach(function(b){b.addEventListener("click",function(){document.querySelectorAll("[data-gc]").forEach(function(x){x.classList.remove("on");});b.classList.add("on");sel=+b.getAttribute("data-gc");});});var buy=document.getElementById("gcBuy");if(buy)buy.addEventListener("click",function(){alert("Gift Card $"+sel+" added! Checkout coming soon.");});}giftCard();
  
  
  
  
  

  // ---- lazy TikTok iframes (mobile perf) ----
  (function(){
    function loadIfr(el){var d=el.getAttribute('data-src');if(d){el.setAttribute('src',d);el.removeAttribute('data-src');}}
    var ifrs=Array.prototype.slice.call(document.querySelectorAll('iframe.lazy-ifr[data-src]'));
    if(!ifrs.length)return;
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){loadIfr(en.target);io.unobserve(en.target);}});},{rootMargin:'600px 0px'});
      ifrs.forEach(function(el){io.observe(el);});
    } else { ifrs.forEach(loadIfr); }
  })();

  // ---- apply Experience/Size selection passed from crate page to Shopify product form ----
  function applyProductParams(){
    try{
      var p=new URLSearchParams(window.location.search);
      var exp=p.get('exp'), size=p.get('size');
      var ep=document.getElementById('prop-exp'); if(ep && exp) ep.value=exp;
      var sp=document.getElementById('prop-size'); if(sp && size) sp.value=size;
      // pre-select matching Shopify Size option if present
      if(size){
        var sels=document.querySelectorAll('#product-form select[name^="options"]');
        sels.forEach(function(sel){
          for(var i=0;i<sel.options.length;i++){
            if(sel.options[i].value.toUpperCase()===size.toUpperCase()){ sel.selectedIndex=i; break; }
          }
        });
      }
      // show a small confirmation line so the customer sees their choice carried over
      if((exp||size)){
        var f=document.getElementById('product-form');
        if(f && !document.getElementById('carryNote')){
          var n=document.createElement('p'); n.id='carryNote';
          n.style.cssText='margin:10px 0;color:#F26522;font-weight:700;font-size:.95rem';
          n.textContent='Your selection: '+[exp,size?('Size '+size):''].filter(Boolean).join(' · ');
          f.insertBefore(n, f.firstChild);
        }
      }
    }catch(_e){}
  }

  try{applyProductParams();}catch(_e){}


  try{go();}catch(_e){if(window.console)console.warn("init fail:go",_e);}
})();
// ---- estimated delivery date calculator ----
(function(){
  function addBizDays(date, days){
    var d = new Date(date);
    while(days > 0){
      d.setDate(d.getDate()+1);
      var day = d.getDay();
      if(day !== 0 && day !== 6) days--;
    }
    return d;
  }
  function fmt(d){
    return d.toLocaleDateString('en-AU', { weekday:'short', day:'numeric', month:'short' });
  }
  function fillEstimates(){
    var els = document.querySelectorAll('[data-est-delivery]');
    if(!els.length) return;
    var now = new Date();
    var lo = addBizDays(now, 2);   // 24h dispatch + ~1-2 business days transit (AUS metro fast lane)
    var hi = addBizDays(now, 5);   // wider regional/interstate window
    var txt = fmt(lo) + ' – ' + fmt(hi);
    els.forEach(function(el){ el.textContent = txt; });
  }
  fillEstimates();
  document.addEventListener('click', function(){ setTimeout(fillEstimates, 60); });
})();
